import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { logger } from "../logger";
/* Функция-утилита для запуска методов зарегистрированных экземпляров классов метрик */
export function fireEvents(eventNames, helpers, data) {
  var events = eventNames.split(',');
  events.forEach(function (event) {
    var _event$split = event.split(':'),
      _event$split2 = _slicedToArray(_event$split, 2),
      metricName = _event$split2[0],
      methodName = _event$split2[1];
    try {
      var _helpers$metricName, _helpers$metricName$m;
      helpers === null || helpers === void 0 ? void 0 : (_helpers$metricName = helpers[metricName]) === null || _helpers$metricName === void 0 ? void 0 : (_helpers$metricName$m = _helpers$metricName[methodName]) === null || _helpers$metricName$m === void 0 ? void 0 : _helpers$metricName$m.call(_helpers$metricName, data);
    } catch (e) {
      logger.error('Ошибка вызова метрики!', [metricName, methodName], ['Error', e]);
    }
  });
}
export function convertEventsConfig(events) {
  return Object.keys(events).reduce(function (acc, key) {
    var methods = events[key];
    var preparedMethods = methods === null || methods === void 0 ? void 0 : methods.map(function (method) {
      return "".concat(key, ":").concat(method);
    });
    return [].concat(_toConsumableArray(acc), _toConsumableArray(preparedMethods || []));
  }, []).join(',');
}